import { render, staticRenderFns } from "./airnzuaJointVentureTC.vue?vue&type=template&id=67283eba&scoped=true&"
import script from "./airnzuaJointVentureTC.vue?vue&type=script&lang=js&"
export * from "./airnzuaJointVentureTC.vue?vue&type=script&lang=js&"
import style0 from "./airnzuaJointVentureTC.vue?vue&type=style&index=0&id=67283eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67283eba",
  null
  
)

export default component.exports